import React, { Component } from 'react';

class Currency extends Component {

    state = {
        currencies: [' ', '¥', '€', '$', '£'],
    }

    render() {
        const { currency } = this.props;

        return (
    		<span>
                { this.state.currencies[currency] }
        	</span>
        );
    }
  
}

export default Currency;
